import { render, staticRenderFns } from "./whiteLabel.vue?vue&type=template&id=0d3b573a&scoped=true"
import script from "./whiteLabel.vue?vue&type=script&lang=js"
export * from "./whiteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b573a",
  null
  
)

export default component.exports